import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach Bearer access token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// 401 handler → prompt login dialog, 429 → surface lockout toast
let unlockHandler = null;
export const setUnlockHandler = (fn) => { unlockHandler = fn; };

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const method = (err?.config?.method || "").toLowerCase();
    if (status === 401 && method !== "get") {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      if (unlockHandler) unlockHandler();
    }
    return Promise.reject(err);
  }
);

export const STATUS_META = {
  FULL_SUPPLY:    { label: "FULL SUPPLY",    bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/40", hex: "#10B981" },
  WAITING_SUPPLY: { label: "WAITING SUPPLY", bg: "bg-amber-500/15",   text: "text-amber-300",   border: "border-amber-500/40",   hex: "#F59E0B" },
  WAITING_PO:     { label: "WAITING PO",     bg: "bg-violet-500/15",  text: "text-violet-300",  border: "border-violet-500/40",  hex: "#8B5CF6" },
  WAITING_QUOT:   { label: "WAITING QUOT",   bg: "bg-cyan-500/15",    text: "text-cyan-300",    border: "border-cyan-500/40",    hex: "#06B6D4" },
  WAITING_SPP:    { label: "WAITING SPP",    bg: "bg-rose-500/15",    text: "text-rose-300",    border: "border-rose-500/40",    hex: "#F43F5E" },
  CANCEL:         { label: "CANCEL",         bg: "bg-slate-500/20",   text: "text-slate-300",   border: "border-slate-500/40",   hex: "#6B7280" },
};

export const fmtNumber = (n) => new Intl.NumberFormat("id-ID").format(Math.round(n || 0));
export const fmtRupiah = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
export const fmtDate = (s) => (s ? String(s).slice(0, 10) : "-");

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
